import Vue from "vue";
import VueI18n from "vue-i18n";
import BaseConfig from '@/config/base.js'

import * as EN from './JsonModule/en.js'
import * as PT from './JsonModule/pt.js'
import * as ES from './JsonModule/es.js'
import * as AR from './JsonModule/ar.js'
import * as TR from './JsonModule/tr.js'
import * as FR from './JsonModule/fr.js'
import * as ID from './JsonModule/id.js'
import * as DA from './JsonModule/da.js'
import * as DE from './JsonModule/de.js'
import * as IT from './JsonModule/it.js'

import * as UK from './JsonModule/uk.js'
import * as Pl from './JsonModule/pl.js'
import * as RU from './JsonModule/ru.js'
import * as TH from './JsonModule/th.js'
import * as VI from './JsonModule/vi.js'
import * as BN from './JsonModule/bn.js'
import * as HE from './JsonModule/he.js'
import * as RO from './JsonModule/ro.js'
import * as FA from './JsonModule/fa.js'

import Client from "@/assets/scripts/client";

Vue.use(VueI18n);

const messages = {
  'en': EN, // 英文
  'id': ID, // 印尼
  'pt': PT, // 葡萄牙语
  'es': ES, // 西班牙语
  'ar': AR, // 阿拉伯语
  'tr': TR, // 土耳其语
  'fr': FR, // 法语
  'da': DA, // 丹麦语
  'de': DE, // 德语
  'it': IT, // 意大利语
  'uk': UK,
  'pl': Pl,
  'ru': RU,
  'th': TH,
  'vi': VI,
  'bn': BN,
  'he': HE,
  'ro': RO,
  'fa': FA,
};

export function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  // 右对齐
  if (BaseConfig.rtlLangs.includes(lang)) {
    document.querySelector('html').setAttribute('dir', 'rtl');
  }
  // 左对齐
  else {
    document.querySelector('html').removeAttribute('dir')
  }
  return lang;
}

export function getLanguage () {
  const chooseLanguage = Client.getAppInfoLang();
  if (chooseLanguage) {
    return chooseLanguage;
  }
  return '';
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});

export default i18n;
